import React, { useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  Form,
  Grid,
  Input,
  InputMask,
  Row,
  SimpleCollapse,
  SuccessModal
} from 'components'
import useToggle from 'hooks/useToggle'
import { useForm } from 'react-hook-form'
import { FORMAT, SPACING } from 'utils'
import * as Yup from 'yup'

import { EndPoint } from '../../Consolidation'
import ModalEditConsolidation from '../ModalEditConsolidation/ModalEditConsolidation'
import { CompanyTable } from './components/CompanyTable/CompanyTable'
interface ICompanyCollapse {
  listCompanys: any[]
  add: (data: any, type: EndPoint) => Promise<any>
  edit: (data: any, type: EndPoint) => void
  del: (id: number, type: EndPoint) => void
}

interface ISelectedData {
  idEmpresaConsolidacao: number
  dsEmpresaConsolidacao: string
}

const schema = Yup.object({
  dsEmpresaConsolidacao: Yup.string().required('Empresa é um campo obrigatório')
})

const CompanyCollapse: React.FC<ICompanyCollapse> = ({
  listCompanys,
  add,
  del,
  edit
}) => {
  const typeEndpoint = 'C'
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [isEditing, toggleIsEditing] = useToggle()
  const [isDeleting, toggleIsDeleting] = useToggle()
  const [selectedData, setselectedData] = useState<ISelectedData | undefined>()

  const handleEdit = (data: any) => {
    edit(
      {
        dsEmpresaConsolidacao: data.dsEmpresaConsolidacao,
        idEmpresaConsolidacao: selectedData.idEmpresaConsolidacao
      },
      typeEndpoint
    )
    toggleIsEditing()
  }

  const handleSelectData = (objReq: any, type: 'D' | 'E') => {
    setselectedData(objReq)
    if (type === 'E') {
      isEditing === false && toggleIsEditing()
      return
    }

    if (type === 'D') {
      isEditing === false && toggleIsDeleting()
      return
    }
  }

  const handleAdd = (data) => {
    add(data, typeEndpoint).then(() => {
      reset({ dsEmpresaConsolidacao: '' })
    })
  }

  return (
    <>
      <SimpleCollapse title="Empresa">
        <Grid
          gridCols="2.5fr 0.4fr 5.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
        >
          <Form onSubmit={handleSubmit(handleAdd)}>
            <Row>
              <InputMask
                control={control}
                errors={errors}
                formValue="dsEmpresaConsolidacao"
                label="Empresa"
                placeholder="Digite aqui..."
                maxLength={50}
                type="alfanumeric"
              />
              <Button text="+" type="submit" marginLeft={SPACING.spacing20} />
            </Row>
          </Form>
        </Grid>
        <CompanyTable
          tableData={listCompanys}
          selectedData={handleSelectData}
        />
      </SimpleCollapse>
      {!!isEditing && (
        <ModalEditConsolidation
          isOpen={isEditing}
          onClose={toggleIsEditing}
          handleEdit={handleEdit}
          formValue="dsEmpresaConsolidacao"
          initState={selectedData['dsEmpresaConsolidacao']}
          title="Editar Empresa"
          validationSchema={schema}
        />
      )}
      {!!isDeleting && (
        <SuccessModal
          open={isDeleting}
          message="Tem certeza deseja deletar?"
          type="alert"
          txtButtonCancel="Voltar"
          txtButtonConfirm="SIM"
          handleCancel={toggleIsDeleting}
          handleConfirm={() => {
            del(selectedData.idEmpresaConsolidacao, typeEndpoint)
            toggleIsDeleting()
          }}
        />
      )}
    </>
  )
}

export default CompanyCollapse
